import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, shadow, space } from '../../theme/tokens';

export const Bar = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: ${layout.borderRadiusFull};
  background: ${semantic.bg.surfaceStrong};
  overflow: visible;
  min-height: 56px;
  padding: 0 ${space[1]} 0 0;

  @media screen and (max-width: 768px) {
    background: ${semantic.bg.overlayBlur};
    backdrop-filter: blur(${space[2]});
  }

  @media screen and (max-width: 600px) {
    display: none;
  }
`;

export const DotSeparator = styled.span`
  color: ${semantic.text.tertiary};
  margin: 0 2px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  pointer-events: none;

  @media screen and (max-width: 768px) {
    color: ${semantic.text.inverse};
  }
`;

export const CategoryWrapper = styled.div`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
  margin: 4px;
  margin-right: 0;

  @media screen and (max-width: 600px) {
    display: none;
  }
`;

export const CategoryDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 280px;
  background: ${colors.white};
  border-radius: ${layout.borderRadiusLg};
  box-shadow: ${shadow.lg};
  z-index: ${layout.zIndexDropdown};
  padding: ${space[3]};
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const DatesWrapper = styled.div<{ $isFirst?: boolean }>`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
  border-radius: ${({ $isFirst }) => ($isFirst ? '28px 0 0 28px' : '0')};
`;

export const GuestsWrapper = styled.div`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
`;

export const SearchWrapper = styled.div`
  display: flex;
  height: calc(100% - 8px);
  margin: 4px;
  margin-left: 8px;
`;

export const SearchPill = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${space[1]};
  padding: ${space[3]} ${space[5]};
  background: ${colors.primary};
  border: none;
  border-radius: ${layout.borderRadiusFull};
  color: ${colors.white};
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const SearchLabel = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  &::after {
    content: attr(data-text);
    font-weight: ${fonts.weight.semiBold};
    height: 0;
    overflow: hidden;
    visibility: hidden;
    pointer-events: none;
  }
`;

export const DropdownAnchor = styled.div`
  position: fixed;
  z-index: ${layout.zIndexDropdown};
`;

export const RateDropdownShell = styled.div`
  min-width: 360px;
  border-radius: ${layout.borderRadiusLg};
  box-shadow: ${shadow.lg};
`;

export const RateWrapper = styled.div`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
  padding: ${space[1]} ${space[2]};
`;

export const RateLabelText = styled.span`
  display: inline-block;
  max-width: 10ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RatePillGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${space[1]};
  height: 100%;
  padding: 0 ${space[3]} 0 ${space[5]};
  background: ${colors.white};
  border-radius: ${layout.borderRadiusFull};
`;

export const RatePillLabelButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${space[3]};
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  white-space: nowrap;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
    border-radius: ${layout.borderRadius};
  }
`;

export const ClearRateButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space[5]};
  height: ${space[5]};
  border-radius: ${layout.borderRadiusFull};
  background: transparent;
  color: ${semantic.text.secondary};
  cursor: pointer;
  font-size: ${fonts.size.md};
  line-height: 1;
  padding: 0;
  border: none;
  flex-shrink: 0;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.primary};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const Pill = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  background: ${({ $active }) => ($active ? colors.white : 'transparent')};
  border: none;
  cursor: pointer;
  padding: ${space[3]} ${space[5]};
  height: 100%;
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${({ $active }) => ($active ? fonts.weight.semiBold : fonts.weight.medium)};
  color: ${semantic.text.primary};
  white-space: nowrap;
  border-radius: ${layout.borderRadiusFull};
  transition: background 0.15s ease, font-weight 0.1s ease;

  &:hover {
    font-weight: ${fonts.weight.semiBold};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  @media screen and (max-width: 768px) {
    color: ${({ $active }) => ($active ? semantic.text.primary : semantic.text.inverse)};
  }
`;
